import format from 'date-fns/format';
import { usagesTypesNames } from '../consts';
import paymentTypes from '../../payments/utils/paymentTypes';

export const formatExpirationDate = (expirationDate) => format(expirationDate, 'MM/YYYY');

export const formatPaymentToken = (paymentToken, showExpirationDate = false) => {
  if (paymentToken.type === 'PayPal') {
    return `PayPal ${paymentToken.email}`;
  }
  let card = `${paymentToken.type} ****${paymentToken.lastFourDigits}`;
  card += showExpirationDate ? `, ${formatExpirationDate(paymentToken.expirationDate)}` : '';
  return card;
};

export const filterDefaultPaymentTokens = paymentTokens =>
  (paymentTokens ? paymentTokens.filter(token => token.usages.length !== 0) : []);
export const filterOtherPaymentTokens = paymentTokens =>
  (paymentTokens ? paymentTokens.filter(token => token.usages.length === 0) : []);

export const groupValidPaymentTokens = (paymentTokens, isPayPalPaymentEnabled) => {
  const groups = Object.keys(usagesTypesNames);
  const groupedPaymentTokens = {};
  groups.forEach(group => {
    groupedPaymentTokens[group] = [];
  });

  paymentTokens.forEach(token => {
    const tokenUsages = token.usages;
    if (Array.isArray(tokenUsages) && tokenUsages.length) {
      tokenUsages.forEach(usage => {
        groupedPaymentTokens[usage].push(token);
      });
    } else {
      const isTokenAvailable = token.type !== paymentTypes.PAYPAL || isPayPalPaymentEnabled;
      if (isTokenAvailable) {
        groupedPaymentTokens.NIU.push(token);
      }
    }
  });
  return groupedPaymentTokens;
};
